module.exports = __webpack_public_path__ + "img/folder-green.fa9bdc72.svg";